import "./App.css";
import Allroutes from "./Components/Allroutes";
function App() {
  return (
    <div className="App">
      <Allroutes />
      {/* <Login /> */}
    </div>
  );
}

export default App;
